import Login from "./login";
import PaymentRequired from "./paymentRequired";
import VerifyEmail from "./verifyEmail";
import VerifyEmailRequired from "./verifyEmailRequired";

export default [Login, VerifyEmail, VerifyEmailRequired, PaymentRequired];
